/**
 * Mouse-steering fallback: maps a pointer's viewport (client) coordinates
 * onto board pixel coordinates, given the on-screen rect the board canvas
 * currently occupies (the canvas is CSS-scaled to fit the viewport — see
 * `index.html`'s `.board-canvas` — while the game itself always works in
 * native `BOARD` pixels).
 */

import type { Vec2 } from "../../src";
import { BOARD } from "../../src";

export interface BoardRect {
  readonly left: number;
  readonly top: number;
  readonly width: number;
  readonly height: number;
}

/** Pure: takes the board element's rect explicitly rather than reading the DOM, so it's testable with a plain object. */
export function pointerToBoard(clientX: number, clientY: number, rect: BoardRect): Vec2 {
  const nx = rect.width > 0 ? (clientX - rect.left) / rect.width : 0;
  const ny = rect.height > 0 ? (clientY - rect.top) / rect.height : 0;
  return {
    x: Math.max(0, Math.min(BOARD.w, nx * BOARD.w)),
    y: Math.max(0, Math.min(BOARD.h, ny * BOARD.h)),
  };
}
